import { Box } from "@mui/material";
import { DatePicker } from "./DatePicker";
import { type ISizingWrapperProps } from "../Wrapper";

interface IProps extends Pick<ISizingWrapperProps, "size"> {
  /** MUI TextFieldの表示密度。省略時は従来どおり "medium" */
  muiSize?: "small" | "medium";
  startDateLabel: string;
  displayDateLabel?: boolean;
  startDateDisableFuture?: boolean;
  startDateDisablePast?: boolean;
  startDate: Date | null;
  onChangeStartDate: (date: Date | null) => void;
  onStartDateErrorChange?: (error: unknown) => void;
  endDateLabel: string;
  endDateDisableFuture?: boolean;
  endDateDisablePast?: boolean;
  endDate: Date | null;
  onChangeEndDate: (date: Date | null) => void;
  onEndDateErrorChange?: (error: unknown) => void;
  views?: Array<"year" | "month" | "day">;
  minDate?: Date;
  maxDate?: Date;
  defaultCalendarMonth?: Date;
  inputFormat?: string;
  mask?: string; // inputFormatとmaskは必ずセットで設定する
  disabled?: boolean;
  errorStart?: string; // 開始日のエラーメッセージ
  errorEnd?: string; // 終了日のエラーメッセージ
  requiredStart?: boolean; // 開始日に必須マークを表示するかどうか
  requiredEnd?: boolean; // 終了日に必須マークを表示するかどうか
}

const DateRangePicker: React.FC<IProps> = (props) => {
  const {
    startDateLabel,
    startDateDisableFuture = false,
    startDateDisablePast = false,
    startDate,
    onChangeStartDate,
    onStartDateErrorChange,
    endDateLabel,
    endDateDisableFuture = false,
    endDateDisablePast = false,
    endDate,
    onChangeEndDate,
    onEndDateErrorChange,
    views,
    minDate,
    maxDate,
    defaultCalendarMonth,
    inputFormat,
    mask,
    disabled,
    displayDateLabel = false,
    errorStart,
    errorEnd,
    requiredStart = false,
    requiredEnd = false,
    size,
    muiSize,
  } = props;

  // TODO: UIがダサいのでいい感じに

  return (
    <>
      <Box sx={{ mr: 1 }}>
        <DatePicker
          label={startDateLabel}
          size={size}
          muiSize={muiSize}
          value={startDate}
          views={views}
          onChange={onChangeStartDate}
          onErrorChange={onStartDateErrorChange}
          minDate={minDate}
          /** 開始日の最大値は、終了日または設定された値 */
          maxDate={endDate !== null ? endDate : maxDate}
          disableFuture={startDateDisableFuture}
          disablePast={startDateDisablePast}
          defaultCalendarMonth={defaultCalendarMonth}
          inputFormat={inputFormat}
          mask={mask}
          disabled={disabled}
          displayLabel={displayDateLabel}
          error={errorStart}
          required={requiredStart}
        />
      </Box>

      <DatePicker
        label={endDateLabel}
        displayLabel={displayDateLabel}
        size={size}
        muiSize={muiSize}
        value={endDate}
        views={views}
        onChange={onChangeEndDate}
        onErrorChange={onEndDateErrorChange}
        /** 終了日の最小値は、開始日または設定された値 */
        minDate={startDate !== null ? startDate : minDate}
        maxDate={maxDate}
        disableFuture={endDateDisableFuture}
        disablePast={endDateDisablePast}
        defaultCalendarMonth={defaultCalendarMonth}
        inputFormat={inputFormat}
        mask={mask}
        disabled={disabled}
        error={errorEnd}
        required={requiredEnd}
      />
    </>
  );
};

export { DateRangePicker, type IProps as DateRangePickerIProps };
